import { useChangeLocale } from '@lib/hooks/useChangeLocale';
import { FooterLanguageLink } from '@lib/types/cms/Footer';
import { HeaderMenuListItem } from './HeaderMenuListItem';

type Props = {
  items: FooterLanguageLink[];
};
export const NavigationLanguageLinksColumn = ({ items }: Props) => {
  const handleChangeLocale = useChangeLocale();

  return (
    <ul className="w-full text-white">
      {items.map((language) => (
        <li key={language.title} className="mb-4">
          <HeaderMenuListItem
            hasChildren={false}
            value={language.title}
            data-test={`language-${language.locale}`}
            handleSelect={() => handleChangeLocale(language.locale)}
            lang={language.locale}
          />
        </li>
      ))}
    </ul>
  );
};
